import { 
        InfoContainer2, 
        InfoWrapper, 
        InfoRow, 
        Column1, 
        Column2,
        TextWrapper, 
        TopLine, 
        Heading, 
        Subtitle, 
        ImgWrap, 
        Img 
} from './InfoElements4'

const InfoSection = ({ lightBg, imgStart, topLine, lightText, headline, darkText, description, img, alt }) => {
  return (
    <>
       <InfoContainer2>
            <InfoWrapper id='about'>
                <InfoRow imgStart={imgStart}>
                    <Column1>
                        <TextWrapper>
                            <TopLine>{topLine}</TopLine>
                            <Heading>{headline}</Heading>
                            <Subtitle>{description}</Subtitle>
                        </TextWrapper>
                    </Column1>
                    <Column2>
                        <ImgWrap>
                            <Img src={img} alt={alt} />
                        </ImgWrap>
                    </Column2>
                </InfoRow>
            </InfoWrapper>
        </InfoContainer2> 
    </>
  )
}

export default InfoSection